import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { AuthSevices } from '@fitness-force/api';
import { TransferStatus, TransferType } from '@fitness-force/enum';
import { TENANTSINTERFACE } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { ButtonModule } from 'primeng/button';
import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'transfer-actions',
  templateUrl: './transfer-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule,
    ButtonModule,
    PopoverModule,
    TranslateModule]
})
export class TransferActionsComponent implements OnInit {

  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null) // expected data ["edit","active","inactive"] etc
  @Input() rowIndex: number = 0;

  @Output() onAction = new EventEmitter(); // {type:actionName,columnData }
  showOptions: boolean = false;
  currentUserDetails: any;
  tenantId:number=0;

  constructor( private authService: AuthSevices,private store: Store) { }

  ngOnInit(): void {
    this.currentUserDetails = this.authService.decodedToken;
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
    });
  }

  executeAction(action: string, columnData: any, overlayElement: any) {
    overlayElement.hide();
    this.onAction.emit({ action, columnData: columnData, rowIndex: this.rowIndex });
  }

  isActive(columnData: any): boolean {
    return columnData.status.toUpperCase() == 'Active'.toUpperCase()
  }

  isStatusVoid(columnData: any): boolean {
    return columnData.status.toLowerCase() == "void";
  }

  ShowDecline(columnData:any)
  {
     if(columnData.transfer_type == TransferType.LocationToLocation || columnData.transfer_type == TransferType[TransferType.LocationToLocation])
      {
        if(this.tenantId == columnData.transfer_to_tenant_id) return true
        else return false;
      }
    else return false;
  }

  ShowVoid(columnData:any)
  {
    if(this.tenantId == columnData.transfer_from_tenant_id) return true
    else return false;
  }

  ShowStart(columnData:any)
  {
    if(columnData.transfer_type == TransferType.LocationToLocation || columnData.transfer_type == TransferType[TransferType.LocationToLocation])
    {
      if(this.tenantId == columnData.transfer_to_tenant_id) return true
      else return false;
    }
     else return false;
  }

  showActions(columnData: any): boolean {
    return (columnData.transfer_status !== TransferStatus.Decline && columnData.transfer_status.toString() !== TransferStatus[TransferStatus.Decline])
    && (columnData.transfer_status !== TransferStatus.Completed && columnData.transfer_status.toString() !== TransferStatus[TransferStatus.Completed])  
    && (columnData.transfer_status !== TransferStatus.Void && columnData.transfer_status.toString() !== TransferStatus[TransferStatus.Void]);
  }

  get hasAdminBilling():boolean
  {
    return this.currentUserDetails.can_admin_billing == 'true' ? true: false;
  }

}